export interface UserLabelServiceGetAllParams {
    page?: number;
    per_page?: number;
    order_by?: string;
    word?: string;
    call_participant?: string;
    is_active?: boolean;
    search?: string;
}
